module.exports = __webpack_public_path__ + "assets/2d76f5e9fb74f2da1fbb478c23faacd7.mp3";